
/*! Open drawer on 'Add to cart' — HerBeauty (Shrine Pro) */
(function(){
  var SHOULD_OPEN = false;
  var LAST_SUBMIT_AT = 0;

  function markIntent() {
    SHOULD_OPEN = true;
    LAST_SUBMIT_AT = Date.now();
  }

  // Mark intent when user clicks any add-to-cart submit in product forms or quick-adds
  document.addEventListener('click', function(e){
    var btn = e.target.closest('button[name="add"], [type="submit"][name="add"]');
    if (btn) markIntent();
  }, true);

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form');
    if (!form) return;
    if (form.matches('[data-type="add-to-cart-form"], form[action*="/cart/add"]')) {
      markIntent();
    }
  }, true);

  function openCartDrawer(){
    // 1) Preferred: click the header cart link (theme intercepts to open drawer)
    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      var ev = new MouseEvent('click', {bubbles:true, cancelable:true, view:window});
      cartLink.dispatchEvent(ev);
    }

    // 2) Also try common triggers
    var opener = document.querySelector('[data-drawer-trigger="cart"], [data-cart-open], .js-open-cart, button[aria-controls="CartDrawer"], a[href="#CartDrawer"]');
    if (opener) {
      try { opener.click(); } catch(e) {}
    }

    // 3) Last resort: toggle body class some Shrine builds use
    document.body.classList.add('cart-drawer-open');
  }

  // When cart quantity changes (after successful add), open if the user just tried to add
  document.addEventListener('cartQuantityUpdated', function(e){
    if (!SHOULD_OPEN) return;
    if (Date.now() - LAST_SUBMIT_AT > 4000) { SHOULD_OPEN = false; return; }
    SHOULD_OPEN = false;
    openCartDrawer();
  });

  // Fallback timer: if event never fires, open after short delay
  document.addEventListener('click', function(e){
    if (!SHOULD_OPEN) return;
    setTimeout(function(){
      if (SHOULD_OPEN) { SHOULD_OPEN = false; openCartDrawer(); }
    }, 1200);
  }, true);
})();
